<template>
  <keep-alive>
    <component
      :is="trayComponent"
      :left="position.left"
      :top="position.top"
      :right="position.right"
      :bottom="bottom"
      :pointerPosition="pointerPosition"
      :width="desktopWidth"
      :open="openPercentage === 1"
      :open-percentage="openPercentage"
      ref="trayHolder"
      @openPercentageChangeRequest="onOpenPercentageChangeRequest"
    >
      <slot></slot>
    </component>
  </keep-alive>
</template>

<script>
import { vueWindowSizeMixin } from "vue-window-size";
import OverlayTray from "../atoms/OverlayTray.vue";
import BubbleTray from "../atoms/BubbleTray.vue";

export default {
  name: "Tray",
  mixins: [vueWindowSizeMixin],
  props: {
    targetElementSelector: {
      type: String,
    },
    left: {
      default: null,
    },
    top: {
      default: null,
    },
    right: {
      default: null,
    },
    bottom: {
      default: null,
    },
    pointerPosition: {
      default: null,
    },
    desktopWidth: {
      default: null,
    },
    openPercentage: {
      type: Number,
      required: true,
    },
    responsive: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    OverlayTray,
    BubbleTray,
  },
  data() {
    return {
      position: {
        left: null,
        top: null,
        right: null,
      },
    };
  },
  computed: {
    trayComponent() {
      let trayComponent = OverlayTray;
      if (this.windowWidth >= 1001 || !this.responsive)
        trayComponent = BubbleTray;
      return trayComponent;
    },
  },
  methods: {
    onOpenPercentageChangeRequest({ percentage }) {
      this.$emit("openPercentageChangeRequest", {
        percentage,
      });
    },
    getLocation() {
      this.position.left = this.left;
      this.position.top = this.top;
      this.position.right = this.right;
      // Doing this before the IF statement to check if the element actually exists.
      const targetELement = document.querySelector(this.targetElementSelector);
      if (
        targetELement &&
        this.$refs.trayHolder &&
        this.$refs.trayHolder.$refs.tray &&
        window.innerWidth > 767
      ) {
        const targetBoundingRect = targetELement.getBoundingClientRect();
        if (this.position.left === null) {
          this.position.left = this.calculateLeft(targetBoundingRect);
        }
        this.position.top =
          targetBoundingRect.top + targetBoundingRect.height + 22;
        if (this.position.left + this.desktopWidth >= window.innerWidth) {
          this.position.left = null;
          this.position.right = 8;
        }
      }
    },
    calculateLeft(targetBoundingRect) {
      const trayBoundingRect =
        this.$refs.trayHolder.$refs.tray.getBoundingClientRect();
      return (
        targetBoundingRect.left +
        targetBoundingRect.width / 2 -
        (this.desktopWidth / 2 || trayBoundingRect.width / 2 || 141)
      );
    },
  },
  watch: {
    openPercentage() {
      if (this.openPercentage === 0) return;
      window.requestAnimationFrame(() => {
        this.getLocation();
      });
    },
  },
  mounted() {
    this.getLocation();
  },
};
</script>
